<p-confirmPopup></p-confirmPopup>
<custom-table [config]="customTable" [rowExpansionTemplate]="tableRowexpansion">
</custom-table>

<ng-template #tableRowexpansion let-data>
  <div class="app-card mx-auto border-1 border-top-none border-noround-top">
    <p-tabView>
      <p-tabPanel [header]="translations.actividades" [selected]="true">
        <app-admin-tipo-tramite-actividad [tipoTramiteId]="data.id" [parentData]="data"/>
      </p-tabPanel>
      <p-tabPanel [header]="translations.costos">
        <app-tipo-tramite-costo [tipoTramiteId]="data.id"></app-tipo-tramite-costo>
      </p-tabPanel>
    </p-tabView>
  </div>
</ng-template>

<section>
  <p-dialog [(visible)]="displayTipoTramiteModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
    [resizable]="true" [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '90vw'}"
    class="custom-dialog">

    <ng-template pTemplate="content">
      <app-tramite-wizard [editMode]="true" (onFinalizado)="onFinalizado()"></app-tramite-wizard>
    </ng-template>

  </p-dialog>
</section>

<app-alertas-dialog [headerTitle]="'common.alertas' | translate"></app-alertas-dialog>


<app-admin-tipo-tramite-historial></app-admin-tipo-tramite-historial>
<custom-alert />